import styled from 'styled-components'

export const TopInfo = styled.div`
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 25px;
  padding-bottom: 25px;

  div {
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    .topinfo-icon {
      margin-right: 5px;
      color: #546e7a;
    }

    span {
      color: #546e7a;
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }

  .topinfo-store-name {
    color: #65747b;
    font-size: 16px;
    font-weight: 600;
  }
`

export const MonthGoal = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 22px;

  h2 {
    color: #263238;
    margin: 0;
    font-size: 18px;
  }

  .monthgoal-info {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    color: #65747b;
  }

  .monthgoal-store-info {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    span {
      color: rgba(101, 116, 123, 0.6);
    }

    .monthgoal-store-sellers {
      display: flex;
      align-items: center;

      span {
        margin-right: 5px;
      }
    }
  }
`

export const MainGoal = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  h2 {
    margin: 0px;
    color: #263238;
    font-size: 18px;
  }
`
